export const VOUCHER_TYPE = [
  'cashback',
  'free-shipping',
  'discount'
]
